// Typescript cannot figure out .filter(o => o !== null) will narrow the types of array: 'Type (T | null)[]' is not assignable to type 'T[]'
// https://stackoverflow.com/questions/65487111/filter-in-typescript-got-error-of-string-null-is-not-assignable
export function notNull<T>(val: T | null): val is T {
  return val !== null;
}
